// Соответствие «маршрут → ключи заголовка и подзаголовка» в namespace "menu".
// Используется верхней панелью (Topbar) и заголовками страниц (BlockTitle),
// чтобы не дублировать название раздела внутри содержимого.

export const TITLE_BY_PATH = [
  { test: (p) => p === "/", title: "summary", sub: "summary" },
  { test: (p) => p.startsWith("/schedule"), title: "schedule", sub: "schedule" },
  { test: (p) => p.startsWith("/patient"), title: "patients", sub: "patients" },
  { test: (p) => p.startsWith("/staff"), title: "staff", sub: "staff" },
  { test: (p) => p.startsWith("/warehouse/units"), title: "warehouse.units", sub: "warehouse" },
  { test: (p) => p.startsWith("/warehouse/logs"), title: "warehouse.logs", sub: "warehouse" },
  { test: (p) => p.startsWith("/warehouse"), title: "warehouse.title", sub: "warehouse" },
  { test: (p) => p.startsWith("/services"), title: "services", sub: "services" },
  { test: (p) => p.startsWith("/contacts"), title: "clinics", sub: "clinics" },
  { test: (p) => p.startsWith("/knowledge_base"), title: "knowledgeBase", sub: "knowledgeBase" },
  { test: (p) => p.startsWith("/instructions"), title: "instructions.title", sub: "instructions" },
  { test: (p) => p.startsWith("/finance"), title: "finance.title", sub: "finance" },
  { test: (p) => p.startsWith("/templates"), title: "templates.title", sub: "templates" },
  { test: (p) => p.startsWith("/settings"), title: "settings.title", sub: "settings" },
];

export const resolvePageMeta = (pathname) => {
  const path = pathname || "/";
  return TITLE_BY_PATH.find((item) => item.test(path)) || null;
};

// Пути, на которых заголовок страницы уже показывает верхняя панель
// (это «корни» пунктов меню). Внутри таких страниц свой заголовок-шапка
// больше не нужен — остаются только кнопки действий в верхней панели.
export const SECTION_PATHS = [
  "/",
  "/schedule",
  "/patient",
  "/staff",
  "/warehouse",
  "/warehouse/units",
  "/warehouse/logs",
  "/services",
  "/contacts",
  "/knowledge_base",
  "/finance/accounts",
  "/finance/transaction_history",
  "/templates/treatment_plans",
  "/templates/recommendation",
  "/settings/logs",
  "/settings/integrations",
];

export const normalizePath = (pathname) => {
  const path = String(pathname || "/").split(/[?#]/)[0];
  return path.length > 1 ? path.replace(/\/+$/, "") : "/";
};

// true — заголовок раздела уже в верхней панели, дубль не нужен
export const isSectionPage = (pathname) =>
  SECTION_PATHS.includes(normalizePath(pathname));

export default resolvePageMeta;
